import React, { PropsWithChildren, RefObject, useEffect, useId, useRef, useState } from 'react';
import clsx from 'clsx';

import { useClickOutside } from '@/hooks/useClickOutside';
import { Icon } from '@/stories/atoms/Icon/Icon';
import styles from './modal.module.css';

export type UseModalProps = {
  /** The dialog elment ref */
  ref: RefObject<HTMLDialogElement| null>,
  /** Open modal by default */
  isOpen?: boolean,
  closeCallback?: () => void
}

export const useModal = ({ref, isOpen = false, closeCallback}: UseModalProps) => {
  const [open, setOpen] = useState(isOpen)

  useClickOutside(ref, () => {
    setOpen(false)
    if (closeCallback) closeCallback()
    document.body.classList.remove('has-dialog')
  }, open)
  
  useEffect(() => {
    if (open) {
      ref.current?.showModal();
      document.body.classList.add('has-dialog')
    } else {
      document.body.classList.remove('has-dialog')
      ref.current?.close()
    }
  }, [open, ref]);


  return {open, setOpen}
}

export type ModalProps = {
  /** Modal open by default ? */
  open?: boolean,
  /** on close callbacks */
  onClose: () => void,
  className?: string
} & PropsWithChildren

export const Modal = ({ open: isOpen = false, onClose, className, children, ...props}: ModalProps)=> {
  const dialog = useRef<HTMLDialogElement>(null)
  useModal({ref: dialog, isOpen, closeCallback: onClose})
  useClickOutside(dialog, () => onClose(), isOpen)
  const id = useId()

  const closeModale = () => {
    document.body.classList.remove('has-dialog')
    onClose()
  }

  return (
    <dialog ref={dialog} className={clsx(styles.dialog, className)} onCancel={closeModale} {...props} id={id}>
      <button type='button' className={styles.close} onClick={closeModale}><span className='sr-only'>Fermer la modale</span><Icon icon='close' size={'2x'}/></button>
      <div className={styles.content}>
        {children}
      </div>
    </dialog>
  )
};
